//httpConfig.interceptor.ts
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AuthService } from './services/auth/auth.service';
import { NavigationService } from './navigation.service';

/// Endpoints reachable without a session. A signing link is handed to people who
/// have no account here at all, so these calls must not carry (or depend on) a
/// session, and a rejection from them must not be read as session death — see
/// docs/timesheet-form-signature-links-backend-spec.md § 1.
const PUBLIC_API_PATH = '/api/public/';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService, private navService: NavigationService) { }


  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //const deviceSerial = this.auth.currentDeviceSerial.value;

    const isPublic = request.url.includes(PUBLIC_API_PATH);

    const deviceSerial = localStorage.getItem('deviceSerial')

    //Authentication by setting header with token value
    if (deviceSerial) {
      request = request.clone({
        setHeaders: {
          'Device': deviceSerial
        }
      });
    }

    if (!request.headers.has('Content-Type')) {
      request = request.clone({
        setHeaders: {
          'content-type': 'application/json'
        }
      });
    }

    request = request.clone({
      headers: request.headers.set('Accept', 'application/json')
    });

    // Check if sid parameter is not present, then retrieve from local storage
    
    // Never attach a session to a public call. A signed-in user opening a link they
    // issued would otherwise send their own sid, blurring who actually signed.
    if (!isPublic && !request.params.has('sid')) {
      const sid = localStorage.getItem('currentSessionID');
      const oauth = localStorage.getItem('oauth2');
      if (sid) {
        request = request.clone({
          params: request.params.set('sid', sid)
        });
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${oauth}`
          }
        });
        //console.log('Request with SID:', request);
      }
    }

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          //  console.log('event--->>>', event);
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        console.error(error);
        // The spec forbids 401/403 on public routes precisely because of the logout
        // below; this guard is the belt to that suspenders. Without it a foreman who
        // opened their own test link would be thrown out to the login screen.
        if (!isPublic && (error.status === 401 || error.status === 403)) {
          const returnUrl = this.navService.getLastUrl();
          this.authService.logout(returnUrl, true); // Clear token and user info
        }
        return throwError(error);
      }));
  }


}